









import { defineComponent } from '@vue/composition-api';

/**
 * 备注说明文案
 */
export default defineComponent({
  name: 'RemarkText',
  props: {
    remarkText: {
      type: String,
      default: '',
    },
  },
});
